module.exports = __webpack_public_path__ + "img/empty-box.4e285105.svg";